// v2.19.1 — SuggestedQuestionsChips
// Affiche 3-4 questions cliquables sous le message de greeting d'un mode.
// Click sur une chip → onPick(question) qui re-poste comme question utilisateur.

import { memo } from "react";

function SuggestedQuestionsChipsInner({ questions, accent = "#FF7E1B", onPick, disabled = false, testId = "suggested-questions-chips" }) {
  if (!Array.isArray(questions) || questions.length === 0) return null;
  return (
    <div
      className="civ-suggested-chips"
      data-testid={testId}
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        marginTop: 12,
        paddingTop: 4,
      }}
    >
      {questions.map((q, i) => (
        <button
          key={i}
          type="button"
          className="civ-suggested-chip"
          onClick={() => onPick && onPick(q)}
          disabled={disabled}
          data-testid={`suggested-chip-${i}`}
          style={{
            padding: "8px 14px",
            borderRadius: 999,
            border: `1.5px solid ${accent}66`,
            background: `${accent}14`,
            color: accent,
            fontSize: 13,
            fontWeight: 600,
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.6 : 1,
            transition: "background 0.15s, transform 0.1s",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: 1.2,
          }}
          onMouseEnter={(e) => {
            if (!disabled) {
              e.currentTarget.style.background = `${accent}28`;
            }
          }}
          onMouseLeave={(e) => {
            if (!disabled) {
              e.currentTarget.style.background = `${accent}14`;
            }
          }}
        >
          {q}
        </button>
      ))}
    </div>
  );
}

const SuggestedQuestionsChips = memo(SuggestedQuestionsChipsInner);
export default SuggestedQuestionsChips;
